<template>
  <div>
    <div v-if="collectionResults && collectionResults.length">
      <div
        v-for="(job, index) in collectionResults || []"
        :key="`job-slab${index}`"
        class="columns is-multiline pa-3 is-left-paddingless-mobile is-right-paddingless-mobile"
      >
        <div
          class="column is-12 card is-outlined pointer lift-shadow"
          @click="openJobDetail(job.slug)"
        >
          <div class="card-content pl-0 pr-2">
            <div
              v-if="['Newspaper', 'Web'].includes(job.job_source)"
              class="is-pulled-right column is-1-mobile is-paddingless"
            >
              <vue-icon-base
                height="18"
                width="18"
                :path="$options.icons[$kc('uni-newspaper')]"
              >
              </vue-icon-base>
            </div>
            <div
              class="columns is-vcentered is-multiline is-mobile"
              align="center"
            >
              <div class="column is-2-desktop is-4-mobile">
                <figure class="image is-1 border-1 is-paddingless">
                  <img
                    class="logo-image"
                    :src="get(job, 'organization.logo')"
                  />
                </figure>
                <div
                  v-if="screen !== 'mobile'"
                  class="has-text-left is-size-7 pt-2"
                >
                  Views:
                  <span class="has-text-weight-bold">{{
                    job.hit_count || 0
                  }}</span>
                </div>
              </div>
              <div class="column has-text-left is-3-desktop is-7-mobile">
                <div
                  v-if="isJobTitleValid(job.job_title)"
                  class="is-size-5-mobile is-size-6-desktop has-text-weight-bold has-text-grey"
                  v-text="formatJobTitle(job.job_title)"
                ></div>
                <div
                  v-else
                  class="is-size-5-mobile is-size-6-desktop has-text-weight-bold has-text-grey"
                  v-text="job.job_title"
                ></div>
                <div
                  class="is-size-7"
                  v-text="get(job, 'organization.name')"
                ></div>
                <div
                  class="is-size-7 has-text-grey"
                  v-text="get(job, 'organization.industry')"
                ></div>
              </div>
              <div class="column is-7-desktop is-12-mobile pl-3 has-text-left">
                <div class="is-size-7">
                  {{ $t('salary') }} :
                  <b>{{ job.offered_salary }}</b>
                </div>
                <div class="is-size-7">
                  {{ $t('location') }} :
                  <b>{{
                    job.job_locations.map(l => l.full_address).toString()
                  }}</b>
                </div>
                <div class="is-size-7">
                  {{ $t('No of Vacancies') }} :
                  <b>{{ job.vacancies }}</b>
                </div>
                <div v-if="job.benefits.length" class="is-size-7">
                  {{ $t('Benefits') }}:
                  <div class="ml-4">
                    <b v-for="benefits in job.benefits" :key="benefits">
                      <li>
                        {{ benefits }}
                      </li>
                    </b>
                  </div>
                </div>
              </div>
              <div
                v-if="screen === 'mobile'"
                class="column is-2-desktop is-5-mobile has-text-left"
              >
                <div class="has-text-left is-size-7 pt-0">
                  Views:
                  <span class="has-text-weight-bold"
                    >{{ job.hit_count || 0 }}
                  </span>
                </div>
              </div>
              <div
                v-if="job.tags.length && showTags"
                class="has-text-left my-0 py-0"
              >
                <template v-for="item in job.tags">
                  <a
                    :key="item.slug"
                    class="my-0 mx-1 font-weight-bold mb-5 is-size-8"
                    @click="$emit('selectedTag', item)"
                  >
                    #{{
                      $i18n.locale === 'ne' && item.name_ne
                        ? item.name_ne
                        : item.name
                    }}
                  </a>
                </template>
              </div>
            </div>
          </div>
        </div>
        <JobApplyConfirmation
          v-if="confirmApply"
          :selected-job="job"
          :modal-id="job.id"
        ></JobApplyConfirmation>
        <div
          v-if="googleAd[index]"
          class="column is-12 mt-2 pb-0 has-text-centered ad-block"
        >
          <dfp-slot
            :id="`div-gpt-ad-${googleAd[index].id}-0`"
            mapping-job-search
            :path="`/35754210/${googleAd[index].code}`"
            :size="[
              [728, 90],
              [320, 100]
            ]"
          />
        </div>
      </div>
    </div>
    <div v-else class="column has-text-centered pb-10">
      <div>
        <vue-no-data :loading="loading" :text="text"></vue-no-data>
      </div>
    </div>
    <job-apply-base
      v-if="jobApplyForm.display"
      :next-component="nextComponent"
      :initial-form="initialForm"
      :job-detail="jobApplyForm.jobDetail"
      @success="
        initialForm = false
        jobApplyForm.display = false
        applyJob(jobApplyForm.jobDetail)
      "
      @close="jobApplyForm.display = false"
    ></job-apply-base>
  </div>
</template>

<script>
import JobApplyBase from '@/components/Job/Apply/Base'
import VueIconBase from '@/components/Commons/VueIconBase'
import { uniNewspaper } from '@/helpers/icons'
import VueNoData from '@/components/Commons/VueNoData'
import DfpSlot from '@/components/DfpSlot'
import JobApplyConfirmation from '@/components/Job/Apply/JobApplyConfirmation.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    JobApplyBase,
    VueIconBase,
    VueNoData,
    DfpSlot,
    JobApplyConfirmation
  },
  icons: {
    uniNewspaper
  },
  props: {
    collectionName: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: 'No data available at the moment'
    },
    showTags: {
      type: Boolean,
      deafult: false
    }
  },
  data() {
    return {
      confirmApply: false,
      loading: false,
      endpoint: '',
      initialForm: false,
      nextComponent: '',
      jobApplyForm: {
        jobDetail: {},
        display: false
      },
      googleAd: {
        2: {
          id: 1585903627084,
          code: 'RJ_JS_L1'
        },
        5: {
          id: 1585903662114,
          code: 'RJ_JS_L2'
        },
        6: {
          id: 1585903692030,
          code: 'RJ_JS_L3'
        }
      }
    }
  },
  computed: {
    ...mapGetters({ screen: 'getScreen' }),
    collectionResults() {
      return this.get(
        this.$store.state.collection.collectionResponses,
        `${this.collectionName}.results`
      )
    }
  },
  methods: {
    openPopup(id) {
      const modal = document.getElementById(`${id}`)
      modal.style.display = 'block'
    },
    openJobDetail(slug) {
      if (this.localePath) {
        this.$router.push(
          this.localePath({
            name: 'job-jobSlug-detail',
            params: { jobSlug: slug }
          })
        )
      }
    },
    isJobTitleValid(jobTitle) {
      return (
        jobTitle.length > 15 &&
        jobTitle.includes('/') &&
        !jobTitle.includes(' ')
      )
    },
    formatJobTitle(jobTitle) {
      return jobTitle.replace('/', '/ ')
    }
  }
}
</script>
<style scoped>
.grey {
  background-color: rgb(163, 168, 172);
  color: white;
}
.is-size-8 {
  font-size: 0.7rem;
}

.ad-block {
  overflow: hidden;
}
</style>
